import {
    Directive,
    ComponentRef,
    ViewContainerRef,
    Input,
    ComponentFactoryResolver,
    OnChanges,
    SimpleChanges,
    HostListener
} from '@angular/core';
import { TooltipContentComponent } from './TooltipContent.component';

@Directive({
    selector: '[tooltip-on-click]',
    exportAs: 'tooltiponclick',
    standalone: false
})
export class TooltipOnClickDirective implements OnChanges {
    @Input()
    tooltipContent: string | TooltipContentComponent;
    @Input()
    tooltipShow: boolean;
    @Input()
    tooltipAnimation = true;
    @Input()
    tooltipPlacement: 'top' | 'bottom' | 'left' | 'right' = 'bottom';
    @Input()
    tooltipDelay = 0;
    @Input()
    hideTooltipOnLeave = false;

    private tooltip: ComponentRef<TooltipContentComponent>;
    private visible: boolean;
    private internalTimer: number;

    constructor(
        private viewContainerRef: ViewContainerRef,
        private resolver: ComponentFactoryResolver
    ) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.tooltipShow) {
            if (changes.tooltipShow.currentValue === true) {
                this.show();
            } else {
                this.hide();
            }
        }
    }

    show(): void {
        if (this.visible) {
            return;
        }

        this.visible = true;

        this.internalTimer = window.setTimeout(() => {
            if (!this.tooltipContent) {
                throw new Error(
                    'this.tooltipContent is undefined/null. We need to handle this.'
                );
            }
            if (typeof this.tooltipContent === 'string') {
                const factory = this.resolver.resolveComponentFactory(
                    TooltipContentComponent
                );
                if (!this.visible) {
                    return;
                }

                this.tooltip = this.viewContainerRef.createComponent(factory);
                this.tooltip.instance.hostElement =
                    this.viewContainerRef.element.nativeElement;
                this.tooltip.instance.content = this.tooltipContent;
                this.tooltip.instance.placement = this.tooltipPlacement;
                this.tooltip.instance.animation = this.tooltipAnimation;
            } else {
                const tooltip = this.tooltipContent;
                tooltip.hostElement =
                    this.viewContainerRef.element.nativeElement;
                tooltip.placement = this.tooltipPlacement;
                tooltip.animation = this.tooltipAnimation;
                tooltip.show();
            }
        }, this.tooltipDelay);
    }

    hide(): void {
        if (!this.visible) {
            return;
        }

        this.visible = false;

        clearTimeout(this.internalTimer);

        if (this.tooltip) {
            this.tooltip.destroy();
        }

        if (this.tooltipContent instanceof TooltipContentComponent) {
            this.tooltipContent.hide();
        }
    }

    updateTooltipPosition() {
        if (!this.visible) {
            return;
        }
        const tooltip = this.tooltipContent as TooltipContentComponent;
        tooltip.show();
    }

    @HostListener('focusout')
    @HostListener('mouseleave')
    hideOnLeave(): void {
        if (!this.hideTooltipOnLeave) {
            return;
        }
        this.hide();
    }
}
